<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EAt2jL/tc-custom/9781460379509.jpg?1722379308220" alt="This image is the cover for the book Taming of Delaney Fortune, The Fortunes of Texas: Cowboy Country"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taming of Delaney Fortune, The Fortunes of Texas: Cowboy Country
      </h1>
      <p class="bookDescription body article font2">
        <b>Opposites attract—and seal their deal with a kiss—in this Lone Star State romance from the <i>USA Today</i>–bestselling author of <i>Wildflower Season</i>.</b><br/><br/>He’s been in Horseback Hollow for only a couple of months, but sexy Cisco Mendoza has already made quite an impression! Little does anyone know his real reason for being here—a top secret deal that could shake the foundations of the small Texas town . . . and one important family.<br/><br/>When Delaney Fortune Jones agrees to help Cisco win some hearts and minds, suddenly the tables turn—and the permanent playboy finds himself pining for the innocent cowgirl and her heart of gold. As business veers dangerously close to pleasure, Mr. Mendoza better hang on to his hat—the pint-size Delaney might just teach him a lesson in the art of falling in love . . . Fortune-style!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Major
      </h2>
      
      <p class="authorDescription body article">USA Today bestselling author Michelle Major loves stories of new beginnings, second chances and always a happily ever after. An avid hiker and avoider of housework, she lives in the shadow of the Rocky Mountains with her husband, two teenagers and a menagerie of spoiled furbabies. Connect with her at www.michellemajor.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ec3a118e